class CookieService {
    static set<T>(name: string, value: T, days: number = null): void {
        try {
            const data = {
                value: value,
                expires: days ? Date.now() + days * 24 * 60 * 60 * 1000 : null
            };
            localStorage.setItem(name, JSON.stringify(data));
        }
        catch { }
    }

    static get<T>(name: string, defaultValue: T): T {
        try {
            const item = localStorage.getItem(name);
            if (!item)
                return defaultValue;

            const data = JSON.parse(item) as { value: T; expires: number | null };

            if (data.expires && Date.now() > data.expires) {
                localStorage.removeItem(name);
                return defaultValue;
            }

            return data.value ?? defaultValue;
        }
        catch {
            return defaultValue;
        }
    }

    static delete(name) {
        try {
            localStorage.removeItem(name);
        }
        catch { }
    }
}